import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DataProviders } from "@providers/data-providers.tsx";
import { createRouter, RouterProvider } from "@tanstack/react-router";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import "./index.css";

// Create a new router instance
const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

import "@translations/i18n";

// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <DataProviders>
        <RouterProvider router={router} />
      </DataProviders>
    </StrictMode>,
  );
}
